/**
 * @file main.tsx
 * @summary Point d'entrée Vite/React
 *
 * Monte `<App />` sur `#root`. Importe le CSS global (Tailwind + tokens design system).
 *
 * @see docs/07-CODEBASE.md — conventions de code
 * @see docs/02-FRONTEND.md — design system (tokens HSL, typographie)
 */
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
